import React, { useCallback, useEffect, useRef, useState } from 'react'
import { View, Animated } from 'react-native'
import { Txt, Image, Button, IconButton } from '../../components'
import Identity from '../../utils/Identity'
import { isAndroid, isMobileDevice, openAppIfIsInstalled, isMobileSafari } from '../../tools/platform'
import { useStyles } from './styles'
import { useTheme } from '../../theming/ThemeProvider'
import { appName, appAuthor } from '../../../env.json'
import { storeSave, storeGet } from '../../tools/storage'

const SmartAppBanner = () => {
  const [open, setOpen] = useState(true)
  const [isAppInstalled, setIsAppInstalled] = useState(null)
  const { theme } = useTheme()
  const styles = useStyles(theme)
  const slideDown = useRef(new Animated.Value(-116)).current

  useEffect(() => {
    Animated.timing(slideDown, {
      toValue: 1,
      duration: 5000
    }).start()
  }, [slideDown])

  const getAppIsIntalled = useCallback(async () => {
    const result = await storeGet('mobile-installed-app')
    setIsAppInstalled(result)
  }, [])

  useEffect(() => {
    if (isAppInstalled === null) {
      getAppIsIntalled()
    }
  }, [getAppIsIntalled, isAppInstalled])
  if (!isMobileDevice() || !open || isAppInstalled || isMobileSafari()) {
    return <></>
  }

  const handleClose = () => {
    Animated.timing(slideDown, {
      toValue: 1,
      duration: 1000
    }).start()
    setOpen(false)
  }

  const handleOpen = () => {
    openAppIfIsInstalled()
    storeSave(true, 'mobile-installed-app')
    setOpen(false)
  }
  return (
    <Animated.View
      style={[styles.main, Identity.Shadow(theme).Card, {
        transform: [{
          translateY: slideDown.interpolate({
            inputRange: [0, 1],
            outputRange: [-116, 0] // 0 : 150, 0.5 : 75, 1 : 0
          })
        }]
      }]}
    >
      <View styles={[styles.exitContainer]}>
        <IconButton icon='Exit' color='WHITE' iconColor='SLATE_GRAY' iconSize={12} onPress={handleClose} />
      </View>
      <View style={[styles.imageContainer]}>
        <Image name='Icon' />
      </View>
      <View>
        <Txt text={appName} style={[styles.text]} />
        <Txt text={appAuthor} identity='body3' style={[styles.text]} />
        <Txt text={`Free - ${isAndroid() ? 'In Google Play' : 'On the App Store'}`} style={[styles.text]} />
      </View>
      <View style={[styles.buttonContainer]}>
        <Button
          title='Open' style={[styles.button]} onPress={(e) => {
            e.preventDefault()
            handleOpen()
          }}
        />
      </View>
    </Animated.View>

  )
}

export default SmartAppBanner
